import { wrapIn } from './wrapIn'

export const toLabel = (m: number): string => {
  const h = Math.floor(m / 60)
  const mr = m % 60
  return `${wrapIn(h, 0, 23).toString(10).padStart(2, '0')}:${mr.toString(10).padStart(2, '0')}`
}

export const toMinutes = (input: string): number => {
  // eslint-disable-next-line prefer-const
  let [hours, minutes] = input.split(':').map(p => parseInt(p, 10))
  return hours * 60 + minutes
}
